<template lang="pug">
div.module-sign-in
  div.module-sign-in-content.f.fh
    div
      div(@click="$router.push('/')").f.fc.mb50.cursor-pointer
        img(src="/logo/logo-tate-black.svg").object-fit-cover
      div.f.fc
        ItemSignInWithEmail(ref="itemSignInWithEmail"
          @toggleShowSocialSignIn="showSocialSignIn = !showSocialSignIn")
      div.switch-sign-in-up.f.fc.mt20
        a(@click="onToSignInOrUp"
          ).cursor-pointer.fz14 {{($route.name == 'sign-in') ? 'アカウントをお持ちでない方' : 'アカウントをお持ちの方'}}
      //- div(v-if="showSocialSignIn && $route.name == 'sign-up'").mt40
        span.block.fz11.text-center.mb4 アカウントを登録することにより
        span.block.fz11.text-center 
          | #[a(:href="privacyPolicy" target="blank").fz11 利用規約]・
          | #[a(:href="serviceTerms" target="blank").fz11 個人情報保護方針]に同意したとみなされます
</template>

<style scoped lang="scss">
@import "@/scss/_variables.scss";

.module-sign-in {
  position: relative;
  .module-sign-in-content {
    margin: 0 auto;
    width: $base_width_percent;
    max-width: $base_max_width_px;
    min-height: $device_height;
    span {
      a {
        color: $secondary_text_color !important;
      }
    }
    .switch-sign-in-up {
      color: $secondary_text_color;
    }
  }
}
</style>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState, mapActions } = createNamespacedHelpers('auth')
import ItemSignInWithEmail from '@/components/item/ItemSignInWithEmail'

export default {
  components: {
    ItemSignInWithEmail
  },
  data () {
    return {
      privacyPolicy: 'https://comicaro.id/service_terms.pdf',
      serviceTerms: 'https://comicaro.id/privacy_policy.pdf',
      showSocialSignIn: true
    }
  },
  computed: {
    ...mapState(['isLoggedIn'])
  },
  watch: {
    showSocialSignIn () {
      console.log('this.showSocialSignIn', this.showSocialSignIn)
    }
  },
  methods: {
    onToSignInOrUp () {
      const itemSignInWithEmail = this.$refs.itemSignInWithEmail
      itemSignInWithEmail.status = 'ask_email'
      this.$router.push((this.$route.name == 'sign-in') ?
        '/sign-up' : '/sign-in')
    }
  }
}
</script>